import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom'
import Card from '../../shared/components/UIElements/Card';
import Input from '../../shared/components/formElements/Input';


import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

import companyLogo from'../../assets/logo/logo-print.png';
import {
  VALIDATOR_EMAIL,
  VALIDATOR_MINLENGTH,
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import { AuthContext } from '../../shared/context/auth-context';
import { useHttpClient } from '../../shared/hooks/http-hook';
import './Auth.css';
import "tachyons";
import Footer from "../../shared/components/footer/Footer";
const Auth = () => {
  const auth = useContext(AuthContext);
  const history = useHistory()
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [formState, inputHandler] = useForm(

    {
      email: {
        value: '',
        isValid: false
      },
      password: {
        value: '',
        isValid: false
      }
    },
    false
  );

  const authSubmitHandler = async event => {
    event.preventDefault();
    try {
      const responseData = await sendRequest(
        process.env.REACT_APP_BACKEND_URL+'/auth/login',
        'POST',
        JSON.stringify({
          email: formState.inputs.email.value,
          password: formState.inputs.password.value
        }),
        {
          'Content-Type': 'application/json'
        }
      );

      auth.login(responseData.userId, responseData.token);
      history.push('/')
    } catch (err) {}
  };

  return (
    <React.Fragment>
      <div className="flex flex-column center">
        <div className="logo-container">
          <Link to="/"><img src={companyLogo}  alt="logo"></img> </Link>
        </div> 
      <ErrorModal error={error} onClear={clearError}/>
      <Card className="authentication transparent">            
        {isLoading && <LoadingSpinner asOverlay/>}
        <h2>Login</h2>
        <hr />
        <form onSubmit={authSubmitHandler}>
          <Input
            element="input"
            id="email"
            type="email"
            label="E-Mail"
            validators={[VALIDATOR_EMAIL()]}
            // errorText="Please enter a valid email address."
            onInput={inputHandler}
          />
          <Input
            element="input"
            id="password"
            type="password"
            label="Password"
            validators={[VALIDATOR_MINLENGTH(8)]}
            // errorText="Please enter a valid password, at least 8 characters."
            onInput={inputHandler}
          />
      
           
            {/* <Button type="submit" disabled={!formState.isValid} >
              LOGIN 
            </Button> */}
                               <input 
                type="submit" 
                disabled={!formState.isValid}         
                className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib"               
                value="Sign in" 
            />
   
                       
        </form>
      </Card>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Auth;


